import { render, staticRenderFns } from "./CuentaShowData.vue?vue&type=template&id=28bed55e"
import script from "./CuentaShowData.vue?vue&type=script&lang=js"
export * from "./CuentaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports